// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/lookup-lecturer-classes-request-schema',
  type: 'object',
  required: ['classYear', 'userId'],
  properties: {
    classYear: {
      type: 'integer',
    },
    lectureLessonStatusId: {
      type: 'integer',
    },
    userId: {
      type: 'integer',
    },
    lecturerId: {
      type: 'integer',
    },
    primaryLeadLecturerId: {
      type: 'integer',
    },
    isPrototype: {
      type: 'boolean',
    },
    searchCriteria: {
      type: 'string',
    },
    'paging.CurrentPage': {
      type: 'integer',
    },
    'paging.PageSize': {
      type: 'integer',
    },
    'paging.IncludeCount': {
      type: 'boolean',
    },
    'paging.NoPaging': {
      type: 'boolean',
    },
  },
} as IJSONSchema;

export default schema;
